// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fr-obj-card {\n  border-radius: 4px;\n  border-color: #f4f4f4;\n  margin-bottom: 24px !important;\n}\n.fr-obj-card .ant-card-head {\n  border: none;\n}\n.fr-obj-card .ant-card-body {\n  padding: 12px 24px !important;\n}\n.fr-obj-card .fr-header-desc {\n  word-break: break-all;\n  color: rgba(0, 0, 0, 0.45);\n  margin-left: 6px;\n  font-weight: normal;\n}\n", ""]);
// Exports
module.exports = exports;
